/**
 * Constantes du pack référencement de Max (quotas et prix en centimes HT), SANS aucun import.
 *
 * Pourquoi un fichier à part : les manifestes de fonctionnalités (`feature-manifest/`) sont chargés
 * par le générateur du centre d'aide (`packages/docs-site/scripts/generate-user-docs.ts`, job CI
 * `docs-site`) avec le seul `node_modules` de docs-site, sans `@sinclair/typebox`. Un manifeste qui
 * importerait `subscription.ts` (TypeBox) casse ce job (23/10/2026). `subscription.ts` ré-exporte ces
 * constantes et construit `ADDONS` / `TOPUPS` dessus : une seule source pour la grille, la page
 * tarifs, Pulse et le centre d'aide.
 */

/** Plafond du sélecteur « Liens supplémentaires » (hors lien du pack) — U3. */
export const SEO_EXTRA_BACKLINK_MAX_QUANTITY = 3;
/** Accélérateur 3 mois : 3 liens par mois pendant 3 mois (U4). */
export const SEO_ACCELERATOR_LINKS_PER_MONTH = 3;
export const SEO_ACCELERATOR_MONTHS = 3;
/** Lien mensuel inclus dans le pack référencement. */
export const SEO_PACK_BACKLINKS_PER_MONTH = 1;
/** Plafond structurel : pack + liens supplémentaires + accélérateur (U5). */
export const SEO_MAX_BACKLINKS_PER_MONTH =
  SEO_PACK_BACKLINKS_PER_MONTH + SEO_EXTRA_BACKLINK_MAX_QUANTITY + SEO_ACCELERATOR_LINKS_PER_MONTH;

/** Option « Liens supplémentaires » : prix mensuel HT par lien, en centimes. */
export const SEO_EXTRA_BACKLINK_MONTHLY_PRICE_MINOR = 2500;
/** Option « Doubler mes articles » (4 par semaine au lieu de 2) : prix mensuel HT, en centimes. */
export const SEO_ARTICLES_DOUBLE_MONTHLY_PRICE_MINOR = 2900;
/**
 * Accélérateur référencement : payé une fois à l'achat, en centimes HT. Prix confirmé le
 * 13/10/2026, c'est l'offre d'appel.
 */
export const SEO_BACKLINK_ACCELERATOR_PRICE_MINOR = 19900;
